/**
 * The coin → Petal exchange's rate and daily caps — CLIENT COPIES of server/exchange.js (the derivation is in
 * its header), pinned to it by serverMirrors.test.ts. They exist for the Garden Club copy, which promises the
 * members' unlimited exchange before anyone has asked the server; the exchange panel always shows what GET /api/exchange
 * returns. A leaf module on purpose: sim/subscription.ts reads these while it loads, and sim/exchange.ts
 * imports save.ts, which imports subscription.ts — so keeping them there would read them before they exist.
 */

/** Coins for one Petal. */
export const COINS_PER_PETAL = 25_000;
/** A non-member's Petals per server UTC day. */
export const EXCHANGE_DAILY_PETALS = 30;
/** A Garden Club member's daily cap: none (null) — the exchange is unlimited for members. */
export const MEMBER_EXCHANGE_DAILY_PETALS = null;
